import {
  DepositHistoryPage,
  DepositSchedulePage,
  DepositsPage,
  DepositStatementPage,
} from "@/modules/deposit/pages";
import { FeatureToggle } from "@/shared/common/enums";
import type { BreadcrumbMatch } from "@/shared/common/types";
import { FeatureToggleRoute } from "@/shared/components";
import { Layout } from "@/shared/layout";
import type { RouteObject } from "react-router-dom";

enum Paths {
  Deposits = "deposits",
  DepositHistory = ":depositId/history",
  DepositSchedule = ":depositId/schedule",
  DepositStatement = ":depositId/statement",
}

export const depositRoutes: RouteObject = {
  path: Paths.Deposits,
  element: <Layout/>,
  handle: {
    breadcrumb: () => ({ key: "breadcrumb.deposits" })
  },
  children: [
    { path: "", element: <DepositsPage/> },
    {
      path: Paths.DepositHistory,
      element: <DepositHistoryPage/>,
      handle: {
        breadcrumb: ({ params }: BreadcrumbMatch) => ({
          key: "breadcrumb.depositHistory",
          params: { id: params.id }
        })
      },
    },
    {
      path: Paths.DepositSchedule,
      element: (
        <FeatureToggleRoute
          featureFlag={FeatureToggle.isDepositScheduleAvailable}
          element={<DepositSchedulePage/>}
        />
      ),
      handle: {
        breadcrumb: ({ params }: BreadcrumbMatch) => ({
          key: "breadcrumb.depositSchedule",
          params: { id: params.id }
        })
      },
    },
    {
      path: Paths.DepositStatement,
      element: (
        <FeatureToggleRoute
          featureFlag={FeatureToggle.isDepositStatementAvailable}
          element={<DepositStatementPage/>}
        />
      ),
      handle: {
        breadcrumb: ({ params }: BreadcrumbMatch) => ({
          key: "breadcrumb.depositStatement",
          params: { id: params.id }
        })
      },
    }
  ],
};
